<template>
    <div class="px-1 bg-white">
        <div class="userTitle mt-1 mr-2">Crear Usuario</div>

        <div>
            <validation-observer>
                <b-form>

                    <b-form-group label="Nombre" class="mt-1" label-for="name">
                        <validation-provider #default="{ errors }" name="name" rules="required">
                            <b-form-input id="name" v-model="name" :state="errors.length > 0 ? false : null"
                                name="name" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="Telefono" label-for="telephone">
                        <validation-provider #default="{ errors }" name="telephone" rules="required">
                            <b-form-input id="telephone" v-model="telephone" :state="errors.length > 0 ? false : null"
                                name="telephone" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                     <b-form-group label="Puesto" label-for="position">
                        <validation-provider #default="{ errors }" name="position" rules="required">
                            <b-form-input id="position" v-model="position" :state="errors.length > 0 ? false : null"
                                name="position" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                     <b-form-group label="Correo" label-for="mail">
                        <validation-provider #default="{ errors }" name="mail" rules="required">
                            <b-form-input id="mail" v-model="mail" :state="errors.length > 0 ? false : null"
                                name="mail" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                     <b-form-group label="Rol" label-for="role">
                        <validation-provider #default="{ errors }" name="role" rules="required">
                            <b-form-input id="role" v-model="mail" :state="errors.length > 0 ? false : null"
                                name="role" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>

                    <div>Foto de Perfil</div>
                    <div class="d-flex justify-content-center">
                        <b-img src="@/assets/images/ganImage/uploadImage.png" />
                    </div>
                    <div class="d-flex justify-content-center reportButton mt-1">
                        <b-button  class="bg-primary w-75">
                            <div class="d-flex justify-content-center ">
                                <div class="ml-2">Crear Usuario</div>
                                <div style="color:#D7B92C">
                                    <feather-icon icon="PlusIcon" size="18" class="ml-2" />
                                </div>
                            </div>
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </div>
        <ControlMenu />
    </div>
</template>
<script>
import {BForm, BFormGroup, BFormInput, BButton, BImg} from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations'


export default {
    components: {
        BForm,
        BFormGroup,
        BFormInput,
        BButton,
        BImg,
        ControlMenu,
        required,
        ValidationObserver,
        ValidationProvider,
    },
    data () {
        return {
            mail:'',
            role:'',
            name:'',
            position:'',
            telephone:'',


        }
    },
}
</script>

<style>
.userTitle{
    font-weight: 600;
    font-size: 24px;
}
</style>